<template>
    <div :style="{ height: altezza + 'px' }">
        <Bar :data="data" :options="options" />
    </div>
</template>

<script>
import { Bar } from "vue-chartjs";
import { COLORI } from "@/utils/chart.js";
import Functions from "@/utils/functions.js";

// Grafico a barre (o linea) sui valori in euro, con una seconda serie opzionale
// di conteggi su asse destro (linea).
export default {
    name: "GraficoBarraLineaComponent",
    components: { Bar },

    props: {
        labels: { type: Array, required: true },
        valori: { type: Array, required: true },
        conteggi: { type: Array, default: null },
        etichettaValori: { type: String, default: "Valore" },
        etichettaConteggi: { type: String, default: "N. preventivi" },
        tipoValori: { type: String, default: "bar" }, // "bar" | "line"
        altezza: { type: Number, default: 320 },
    },

    computed: {
        data() {
            const datasets = [{
                type: this.tipoValori,
                label: this.etichettaValori,
                data: this.valori,
                yAxisID: "y",
                backgroundColor: this.tipoValori === "bar" ? COLORI.primarySfumato : COLORI.primary,
                borderColor: COLORI.primary,
                borderWidth: this.tipoValori === "bar" ? 0 : 2,
                pointRadius: this.labels.length > 40 ? 0 : 3,
                tension: 0.25,
                order: 2,
            }];

            if (this.conteggi) {
                datasets.push({
                    type: "line",
                    label: this.etichettaConteggi,
                    data: this.conteggi,
                    yAxisID: "y1",
                    borderColor: COLORI.warning,
                    backgroundColor: COLORI.warning,
                    borderWidth: 2,
                    pointRadius: this.labels.length > 40 ? 0 : 3,
                    tension: 0.25,
                    order: 1,
                });
            }

            return { labels: this.labels, datasets };
        },

        options() {
            const scales = {
                x: { grid: { display: false } },
                y: {
                    beginAtZero: true,
                    ticks: { callback: (v) => Functions.formatEuroCompatto(v) },
                },
            };

            if (this.conteggi) {
                scales.y1 = {
                    position: "right",
                    beginAtZero: true,
                    grid: { drawOnChartArea: false },
                    ticks: { callback: (v) => Functions.formatNumero(v) },
                };
            }

            return {
                responsive: true,
                maintainAspectRatio: false,
                interaction: { mode: "index", intersect: false },
                scales,
                plugins: {
                    legend: { display: !!this.conteggi, position: "bottom" },
                    tooltip: {
                        callbacks: {
                            label: (ctx) => {
                                const formato = ctx.dataset.yAxisID === "y1" ? Functions.formatNumero : Functions.formatEuro;
                                return ctx.dataset.label + ": " + formato(ctx.parsed.y);
                            },
                        },
                    },
                },
            };
        },
    },
};
</script>
